import { decodeEntities } from "@wordpress/html-entities";
import { Observer } from "mobx-react-lite";
import React from 'react';
import { useProps, useStore } from "../../../utils/mobx.utils";
import './PageResultItem.scss';
import { parseExcerpt } from "./PostResultItem";
var PageResultItem = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get page() {
            return p.result;
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null,
            React.createElement("li", { className: "PageResultItem" },
                React.createElement("a", { className: s.page.slug, href: s.page.link },
                    React.createElement("h3", null, decodeEntities(s.page.title.rendered)),
                    React.createElement("p", null, parseExcerpt(s.page.excerpt.rendered, 300)))))); } });
};
export default PageResultItem;
